/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Pdf_Response_InvalidInputs */

const vi_einvoice_error_pdf_response_invalid = /** @type {(inputs: Einvoice_Error_Pdf_Response_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA trả về dữ liệu PDF hóa đơn không hợp lệ. Vui lòng đối soát hóa đơn rồi thử tải lại.`)
};

/**

* @param {Einvoice_Error_Pdf_Response_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_pdf_response_invalid = /** @type {((inputs?: Einvoice_Error_Pdf_Response_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Pdf_Response_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_pdf_response_invalid(inputs)
});